module.exports = __webpack_public_path__ + "static/media/bakingStationImg4.9dc949fe.jpg";